import { FC, MouseEventHandler } from "react";

import { CampaignCardActionsHorizontal } from "shared/ui/cards/campaign-card/shared/campaign-card-actions/campaign-card-actions-horizontal";
import { CampaignCardActionsVertical } from "./campaign-card-actions-vertical";
import { CampaignUserStatusI } from "shared/lib/interfaces/campaign";

export interface CampaignCardActionsI {
  campaign_user_status?: CampaignUserStatusI;
  startCallingUrl?: string;
  assessmentUrl?: string;
  handleOpenSalesFloor?: MouseEventHandler;
  stacked?: boolean;
  onClickTraining?: () => Promise<void> | undefined;
  onClickLeaveCampaign?: () => Promise<void> | undefined;
}

export const CampaignCardActions: FC<CampaignCardActionsI> = ({
  campaign_user_status,
  startCallingUrl,
  assessmentUrl,
  handleOpenSalesFloor,
  stacked = false,
  onClickTraining,
  onClickLeaveCampaign,
}) => {
  return stacked ? (
    <CampaignCardActionsVertical
      campaignUserStatus={campaign_user_status}
      startCallingUrl={startCallingUrl}
      assessmentUrl={assessmentUrl}
      handleOpenSalesFloor={handleOpenSalesFloor}
      onClickTraining={onClickTraining}
      onClickLeaveCampaign={onClickLeaveCampaign}
    />
  ) : (
    <CampaignCardActionsHorizontal
      campaignUserStatus={campaign_user_status}
      startCallingUrl={startCallingUrl}
      assessmentUrl={assessmentUrl}
      handleOpenSalesFloor={handleOpenSalesFloor}
      onClickTraining={onClickTraining}
      onClickLeaveCampaign={onClickLeaveCampaign}
    />
  );
};
